
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";

import { IActionAccessLevel } from "@/store/modules/authModule";
import { EPermissionActions } from "@/model/EPermissionActions";

const authModule = namespace("authModule");

@Component({})
export default class Reports extends Vue {
  @authModule.Action("fetchActionAccessLevels")
  fetchActionAccessLevels!: () => void;

  @authModule.Getter("actionAccessLevels")
  actionAccessLevels!: IActionAccessLevel[];

  get canSeeReports(): boolean {
    let canSee = false;
    this.actionAccessLevels.forEach((each: IActionAccessLevel) => {
      if (each.action == EPermissionActions.ACTION_REPORTS) {
        canSee = true;
      }
    });
    return canSee;
  }

  created() {
    // this will make sure we load actionAccessLevels
    this.fetchActionAccessLevels();
  }
}
